import { StoreResult } from 'api/client-domain/client-domain.types';

type RelatedLocationsType = {
  primaryStore: StoreResult;
  relatedStores: StoreResult[];
};

export const relatedLocations: RelatedLocationsType = {
  primaryStore: {
    storeId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
    title: 'Boston QA (Incentivio)',
    address: {
      streetAddress1: '770 Battaramulla - Pannipitiya Rd',
      streetAddress2: 'Battaramulla 10120',
      city: 'Battaramulla 10120',
      postalCode: '10120',
      region: 'colombo',
      country: 'Sri Lanka',
    },
    phoneNumber: '1541622212',
    shortDescription: 'boston',
    longDescription: 'boston',
    regionId: '00094b0b-7e3b-11ea-892f-0aa9f0965c57',
    storeCode: 'STR:1186678318',
    latitude: 6.892794,
    longitude: 79.928212,
    storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
    beaconId: null,
    beaconName: null,
    smallImage:
      'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
    mediumImage:
      'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
    displayInfo: [
      {
        languageCode: 'EN',
        title: 'Boston QA (Incentivio)',
        shortDescription: 'boston',
        longDescription: 'boston',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
      },
      {
        languageCode: 'FR',
        title: 'Boston QA French',
        shortDescription: 'Boston QA French Short Desc.',
        longDescription: 'Boston QA French Long Desc.',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
      },
    ],
    isMenuBrowsing: false,
    isCatering: false,
    viewOnlyLocationEnabled: false,
  },
  relatedStores: [
    {
      storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
      title: 'Boston QA (Incentivio)',
      address: {
        streetAddress1: '770 Battaramulla - Pannipitiya Rd',
        streetAddress2: 'Battaramulla 10120',
        city: 'Battaramulla 10120',
        postalCode: '10120',
        region: 'colombo',
        country: 'Sri Lanka',
      },
      phoneNumber: '1541622212',
      shortDescription: 'boston',
      longDescription: 'boston',
      regionId: '00094b0b-7e3b-11ea-892f-0aa9f0965c57',
      storeCode: 'STR:1186678318',
      latitude: 6.892794,
      longitude: 79.928212,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Boston QA (Incentivio)',
          shortDescription: 'boston',
          longDescription: 'boston',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
        },
        {
          languageCode: 'FR',
          title: 'Boston QA French',
          shortDescription: 'Boston QA French Short Desc.',
          longDescription: 'Boston QA French Long Desc.',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
      title: "Breckwood Shoppes(QA USE Don't Edit)",
      address: {
        streetAddress1: '12 brookline',
        streetAddress2: 'MA',
        city: 'Boston',
        postalCode: '12345',
        region: 'U.S. Minor Outlying Islands',
        country: 'United States',
      },
      phoneNumber: '+15855764514',
      shortDescription: 'Breckwood Shoppes',
      longDescription: 'Breckwood Shoppes',
      regionId: 'ee5be367-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6326346060',
      latitude: 49.0,
      longitude: 72.0,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Breckwood Shoppes(QA USE DontEdit)',
          shortDescription: 'Breckwood Shoppes',
          longDescription: 'Breckwood Shoppes',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '2ae986f9-ac5c-42a8-8c71-e36dbe591250',
      title: 'Brink Test Store',
      address: {
        streetAddress1: '25 Drydock Avenue',
        streetAddress2: 'Innovation and Design Building',
        city: 'Boston',
        postalCode: '02210',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: '5855764514',
      shortDescription: 'Brink Test Store',
      longDescription: 'Brink Test Store',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3811468360',
      latitude: 42.5076967,
      longitude: -71.3233,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_480110ff3bc347af901d3a28ae50f948.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Brink Test Store',
          shortDescription: 'Brink Test Store',
          longDescription: 'Brink Test Store',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_480110ff3bc347af901d3a28ae50f948.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '9a7e4879-7562-4a86-9478-adb467842ae3',
      title: "Catalog Testing store (Don't Edit)",
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: "Catalog Testing store (Don't Edit)",
      longDescription: "Catalog Testing store (Don't Edit)",
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9513849379',
      latitude: 67.778,
      longitude: 81.106706,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4b6800d8e95b4caa8a4cc13a4160c087.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4457fa0d543d4c6ba8687adfd86c56a5.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: "Catalog Testing store (Don't Edit)",
          shortDescription: "Catalog Testing store (Don't Edit)",
          longDescription: "Catalog Testing store (Don't Edit)",
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4b6800d8e95b4caa8a4cc13a4160c087.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4457fa0d543d4c6ba8687adfd86c56a5.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '3d922e86-2f3f-41b6-a1ce-19ffe94895ad',
      title: 'Decatur',
      address: {
        streetAddress1: '25 Drydock Avenue',
        streetAddress2: 'Innovation and Design Building',
        city: 'Boston',
        postalCode: '02210',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Decatur ( QA USE  Lightspeed)',
      longDescription: 'Decatur ( QA USE  Lightspeed)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:7232830406',
      latitude: 42.5076967,
      longitude: -71.24217759,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Decatur ( QA USE Lightspeed)',
          shortDescription: 'Decatur ( QA USE  Lightspeed)',
          longDescription: 'Decatur ( QA USE  Lightspeed)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '8d86a1ca-dfa9-4c9c-9f4b-6caa81509875',
      title: 'DEV TEAM - QU',
      address: {
        streetAddress1: 'Street Address 1',
        streetAddress2: 'Street Address 2',
        city: 'City',
        postalCode: '33101',
        region: 'Florida',
        country: 'United States',
      },
      phoneNumber: '12333244343',
      shortDescription: 'DEV TEAM - QU',
      longDescription: 'DEV TEAM - QU',
      regionId: 'ee55652b-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:8582747913',
      latitude: null,
      longitude: null,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'DEV TEAM - QU ****',
          shortDescription: 'DEV TEAM - QU',
          longDescription: 'DEV TEAM - QU',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '458d1f38-daeb-4845-8531-7d6dc2cb2a8a',
      title: 'Do Not use (From the Herath Replica)',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Do Not use (From the Herath Replica)',
      longDescription: 'Do Not use (From the Herath Replica)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9009742967',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_1c6e134fd91040399d8d85364f383d2c.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_968c49863a9741928b95aff75a04ef2a.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Do Not use (From the Herath Replica)',
          shortDescription: 'Do Not use (From the Herath Replica)',
          longDescription: 'Do Not use (From the Herath Replica)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_1c6e134fd91040399d8d85364f383d2c.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_968c49863a9741928b95aff75a04ef2a.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '37a5dcaa-f644-4828-b173-fd6d4aa00199',
      title: 'Do Not use (Its boba replica)',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Do Not use (Its boba replica)',
      longDescription: 'Do Not use (Its boba replica)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9988152057',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_7f57d02fb6a3488b8bf4b248f0014984.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_dc4a844242474bf1b63cc01af46b3b5e.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Do Not use (Its boba replica)',
          shortDescription: 'Do Not use (Its boba replica)',
          longDescription: 'Do Not use (Its boba replica)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_7f57d02fb6a3488b8bf4b248f0014984.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_dc4a844242474bf1b63cc01af46b3b5e.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '76cfba32-e232-49bf-acde-4aec97aef1f9',
      title: 'Enfield (QA US  DONT EDIT)',
      address: {
        streetAddress1: '12  brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'U.S. Minor Outlying Islands',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Enfield (QA US DONT EDIT)',
      longDescription: 'Enfield (QA US DONT EDIT)',
      regionId: 'ee5be367-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6827754255',
      latitude: 41.0,
      longitude: 72.0,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Enfield (QA US DONT EDIT)',
          shortDescription: 'Enfield (QA US DONT EDIT)',
          longDescription: 'Enfield (QA US DONT EDIT)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: true,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      title: "Fenway - QA  (Don't Use)",
      address: {
        streetAddress1: 'san juan',
        streetAddress2: null,
        city: 'san juan',
        postalCode: '5455',
        region: 'Puerto Rico',
        country: 'United States',
      },
      phoneNumber: '5515653333',
      shortDescription: "Fenway - QA  (Don't Use)",
      longDescription: "Fenway - QA  (Don't Use)",
      regionId: 'ee5ba3eb-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3346981442',
      latitude: 18.46556,
      longitude: -66.105738,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/imagesss_c6c958e38d1a40f599fccc89e62d4083.jpg',
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: "Fenway - QA  (Don't Use)",
          shortDescription: "Fenway - QA  (Don't Use)",
          longDescription: "Fenway - QA  (Don't Use)",
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/imagesss_c6c958e38d1a40f599fccc89e62d4083.jpg',
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '5dad0de2-0a3b-41ee-aba6-6d928f0f39b0',
      title: "Fenway Kiosk New Dev (Don't Edit)",
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription:
        "KIOSK's self-ordering entry kiosk systems provide convenient & cost-effective solutions for you. Perfect for restaurants, retail, & fast food.",
      longDescription: 'Do not Edit this location',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:5142291674',
      latitude: 42.3608739,
      longitude: -71.104878,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_a63440fb95c043f9a3438c59bb01e569.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_96834253f8d145a8b8390a936c838dde.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Fenway Kiosk New Dev',
          shortDescription:
            "KIOSK's self-ordering entry kiosk systems provide convenient & cost-effective solutions for you. Perfect for restaurants, retail, & fast food.",
          longDescription: 'Do not Edit this location',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_a63440fb95c043f9a3438c59bb01e569.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_96834253f8d145a8b8390a936c838dde.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: true,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: 'f3f970b8-e560-4853-b6ef-0ea4bc3a42e8',
      title: 'Fiddleheads at Bayshore',
      address: {
        streetAddress1: '19 Crosby Drive,',
        streetAddress2: null,
        city: 'Bedford, MA',
        postalCode: '01730',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription:
        'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
      longDescription:
        'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4199894650',
      latitude: 52.1255,
      longitude: 79.125125,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Fiddleheads at Bayshore',
          shortDescription:
            'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
          longDescription:
            'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: 'a8c7020b-27ff-4373-9896-abc4f41d3f59',
      title: 'Henderson',
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'United States',
      longDescription: '12 Brookline Avenue , Boston , US',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9434435023',
      latitude: 52.1255,
      longitude: 79.125125,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_c81fdce158e146519884cd8cd1599c0d.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_63d0cc727f7447fa84cc2e51902c3d81.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Henderson - (QA USE ONLY | Revel )',
          shortDescription: 'United States',
          longDescription: '12 Brookline Avenue , Boston , US',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_c81fdce158e146519884cd8cd1599c0d.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_63d0cc727f7447fa84cc2e51902c3d81.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: true,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '959650e6-c616-45f1-8e80-6b5e5b507e8e',
      title: 'IAC - TOAST',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'IAC - TOAST',
      longDescription: 'IAC - TOAST',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6470588611',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'IAC - TOAST',
          shortDescription: 'IAC - TOAST',
          longDescription: 'IAC - TOAST',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '63b9f30f-62fb-494c-8995-3cc939422f8f',
      title: 'kupfertandkim - Yorkville',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '02116',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'kupfertandkim - Yorkville',
      longDescription: 'kupfertandkim - Yorkville',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3312942008',
      latitude: 42.360081,
      longitude: -71.058884,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'kupfertandkim - Yorkville',
          shortDescription: 'kupfertandkim - Yorkville',
          longDescription: 'kupfertandkim - Yorkville',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
    {
      storeId: '92988170-ccb2-4069-aae9-1e91fd65fd41',
      title: 'Lightspeed - Without Tax Classes',
      address: {
        streetAddress1: '92 Brookeline Street',
        streetAddress2: 'ssss',
        city: 'Boston',
        postalCode: '10300',
        region: 'New York',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Lightspeed  Without Tax Classes',
      longDescription: 'Lightspeed  Without Tax Classes',
      regionId: 'ee5890b6-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:8911618134',
      latitude: 42.3601,
      longitude: 71.0589,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Lightspeed  Without Tax Classes11',
          shortDescription: 'Lightspeed  Without Tax Classes',
          longDescription: 'Lightspeed  Without Tax Classes',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      viewOnlyLocationEnabled: false,
    },
  ],
};
